<template>
<!-- WAIT_FOR_UPLOAD: 1,
    UPLOADING_FROM_BOX: 2,
    UPLOADING_FROM_USER: 3,
    UPLOADING_ERROR: 4,
    RECORDING: 10,
    RECORD_STOPPED: 11,
    RECORD_PAUSED: 12, //al momento non gestito, -->
    <router-link :to="'/events/' + event.id" 
                 class="event-item"  
                 :class="{
                     'not-available': !event.video, 
                     'completed': event.video && event.video.state == $hisport.video_states.COMPLETED,
                     'uploading': event.video && event.video.state == $hisport.video_states.UPLOADING,
                     'not-started': !event.id_user_start,
                     'not-ended': !event.id_user_end,
                     'future': new Date(event.start_timestamp).getTime() > Date.now()
                     }"
                 @click="$route.navigate('/events/' + event.id)" 
                 v-if="!!team_home">
        <event-overlay :event="event" :showStatus="showStatus" :showEdit="showEdit"/>
        <div class="video-preview">
            <!-- <img :src="$hisport.absolute(event.video.preview_url, {default:'/images/event_default.jpg'})"  v-if="event.video && event.video.preview_url"/> -->
            <video :src="event.video.streaming_url_sd" :poster="event.video.preview_url && $hisport.absolute(event.video.preview_url, {default:'/images/event_default.jpg', w: 640, q: 80, f: 'jpg'})" v-if="event.video && event.video.state == $hisport.video_states.COMPLETED" preload="metadata"/>
            <img :src="'/images/event_default.jpg'" v-else style="filter:grayscale(1);opacity:0.5;"/>
        </div>
    </router-link>
</template>
<script>
import eventOverlay from "./event_overlay";
export default {
    components:{
      eventOverlay
    },
    props: {
        event: {
          type: Object,
          default: function(){
              return null;
          }
        },
        showStatus: {
          type: Boolean, 
          default: false
        },
        showEdit: {
          type: Boolean, 
          default: false
        }
    },
    data(){
        return {
            edit: false,
            team_home: {},
            team_foreign: {}
        }
    },
    computed: {
        duration: function(){
            var tse = new Date(this.event.end_timestamp);
            var tss = new Date(this.event.start_timestamp)
            return Math.round((tse.getTime() - tss.getTime()) / (60 * 1000))
        }
    }
}
</script>
<style>
body.mobile .event-item{
   width:min(70vw, 70vh);
   height:min(40vw, 40vh);
}
</style>
<style scoped>
.event-item{
   width:min(30vw, 320px);
   height:min(20vw, 240px);
   position:relative;
   border-radius:var(--border-radius);
   overflow:hidden;
   margin-bottom:max(1vw, 5px);
   color: var(--white);
   z-index:0;
   display:block;
 }
.event-item video{
    width: 150%;
    height: 150%;
    /* margin: -25%; */
    pointer-events: none;
    top: -25%;
    left: -25%;
    position: absolute;
  }
.event-item img{
  width:100%;
  height:100%;
}
/* .event-item.uploading{
    opacity: 0.5;
}
.event-item.not-started,
.event-item.not-ended{
  opacity: 0.5;
} */
.event-item.future{
    filter: grayscale(1);
    opacity:0.5;
}
.event-item .video-overlay{
   width:100%;
   height:100%;
   position:absolute;
   background:url("../../assets/images/overlay2.svg");
   background-size: cover;
 }

.event-item .video-overlay .team-image{
   width:30px;
   height:30px;
   position:absolute;
   top:15px;
   left:15px;
   background:var(--white);
   border-radius: var(--border-radius);
   text-align:center;
   padding:5px;
   box-sizing: border-box;
 }
 .event-item .video-overlay .team-image img{
    max-width: 100%;
    max-height:100%;
  }
 .event-item .video-overlay .team-image.foreign_team{
    left:50px;
  }
.event-item .video-overlay .score{
    width:48px;
    height:30px;
    position:absolute;
    top:15px;
    right:15px;
    border-radius: var(--border-radius);
    text-align:center;
    padding:5px;
    box-sizing: border-box;
    background: rgba(0,14,41,0.6) 0% 0% no-repeat padding-box;
    border-radius: 7px;
    font-weight:bold;
    font-size:18px;
 }
.event-item .video-overlay .favorite{
    position:absolute;
    bottom:10px;
    right:15px;
    text-align:center;
    box-sizing: border-box;
 }
.event-item .video-overlay .header{
    width:calc(100% - 30px);
    height:45px;
    position:absolute;
    bottom:15px;
    left:15px;
    border-radius: var(--border-radius);
    text-align:center;
    padding:5px;
    box-sizing: border-box;
    font-weight:bold;
    font-size:13px;
    display:flex;
    flex-direction: column;
    text-align:left;
 }

.event-item .video-overlay .header .subtitle{
  margin-top:15px;
  font-size:10px;
  font-weight:normal;
}
.event-item .video-overlay .header .subtitle .datetime{
  font-weight:bold;
  text-transform: capitalize;
}
.event-item .video-overlay .header .subtitle>* + *:before{
  content: "•";
  width:10px;
  display:inline-block;
  text-align: center;
}
.event-item .video-preview{
   width:100%;
   height:100%;
 }
.event-item .video-preview img{
   width:100%;
   height:100%;
 }
</style>